/*! @azure/msal-common v15.7.0 2025-05-30 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.7.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
